import { Button, Tooltip } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const DownloadPdfForm = ({
  pdfUrl,
  fileName,
}: {
  fileName: string;
  pdfUrl: string | null;
}) => {
  const handleDownload = () => {
    if (!pdfUrl) return;
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = `${fileName}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Tooltip title={pdfUrl ? 'Download PDF' : 'PDF not yet available.'} placement="top" arrow enterNextDelay={2000} enterDelay={2000}>
      <span>
        <Button
          onClick={handleDownload}
          disabled={!pdfUrl}
          variant="contained"
          disableElevation
          size="small"
          className="normal-case !text-white bg-mainblue hover:bg-mainblue/90 disabled:!bg-mainblue disabled:!opacity-40"
          startIcon={<DownloadIcon style={{ fontSize: 14 }} />}
        >
          <span className="text-xs">Download</span>
        </Button>
      </span>
    </Tooltip>
  );
};

export default DownloadPdfForm;
